(function (angular) {
  "use strict";

  var INIT_DELAY_MS = 50;

  angular.module("Toyota.Directives").directive("tyAccordion", [
    "$timeout",
    "$parse",
    function ($timeout, $parse) {
      return {
        link: function ($scope, $element) {
          var $triggers = $element.find("[data-ty-accordion-trigger]");
          var $items = $element.find("[data-ty-accordion-item]");
          var $bodies = $element.find("[data-ty-accordion-body]");
          var animationTime = 300; // Should be the same time as the CSS transition
          var timeout = null;

          var handleAccordionTriggerOpenClicked = function ($trigger) {
            $parse($trigger.attr("data-accordion-trigger-on-open-clicked"))($scope);
          };

          var handleAccordionTriggerCloseClicked = function ($trigger) {
            $parse($trigger.attr("data-accordion-trigger-on-close-clicked"))($scope);
          };

          var getItemFromTrigger = function ($trigger) {
            return $trigger.closest("[data-ty-accordion-item]");
          };

          var getItemIsOpen = function ($item) {
            return $item.hasClass("is-open");
          };

          /**
           * setHeight - Sets the CSS height style attribute on the target item's
           *             content area to the value of the item's content area height.
           *
           *             The height value is 0 if the item is collapsing.
           *
           *             We have to explcitly set the height of the items because CSS
           *             transitions do not work between an integer and 'auto'
           *
           * @param  {Object} $body  the body object
           * @param  {Number} height the height of the item's content area
           * @return {void}
           */
          var setHeight = function ($body, height) {
            $body.css({
              height: height,
            });

            $bodies.not($body).css({
              height: 0,
            });
          };

          /**
           * removeAnimationClass - Removes the is-animating class from all items
           *                        This function should only be triggered after the
           *                        animation period has elapsed.
           *
           * @return {void}
           */
          var removeAnimationClass = function () {
            $items.removeClass("is-animating");
          };

          /**
           * setClasses - If the item is expanding, the is-open and is-animating
           *              classes are added.
           *
           *              If the item is collapsing, the is-open
           *              class is removed, and the is-animating class is added
           *              to the target element.
           *
           *              The is-open class is removed from all items that aren't
           *              the target item.
           *
           *              The setTimeout() call then removes the is-animating class
           *
           * @param  {Object} $item the target item
           * @return {void}
           */
          var setClasses = function ($item) {
            $items.filter(".is-open").addClass("is-animating");
            $items.not($item).removeClass("is-open");
            $item.toggleClass("is-open").addClass("is-animating");

            if (timeout) {
              clearTimeout(timeout);
            }

            timeout = setTimeout(removeAnimationClass, animationTime);
          };

          /**
           * expandForPrint - Removes the inline height attribute from all content areas.
           *
           *                  Styles in the component stylesheet change how the accordion
           *                  displays when printed.
           *
           * @return {void}
           */
          var expandForPrint = function () {
            $bodies.css({
              height: "",
            });
          };

          /**
           * setAriaValues - Toggles the aria-expanded value on the target item,
           *                 and sets it to false on all items that are not the
           *                 target item.
           *
           * @param  {Object} $trigger  the trigger within the target item
           * @param  {boolean} isOpen   if true the target item is currently open
           * @return {void}
           */
          var setAriaValues = function ($trigger, isOpen) {
            $triggers.not($trigger).attr("aria-expanded", "false");
            $trigger.attr("aria-expanded", isOpen);
          };

          /**
           * toggle - Sets the inline height property of an expanding item, toggles the
           *          is-open class value all items, updates the aria-expanded
           *          attribute value of all items, and fires any consumer-supplied event
           *          handlers
           *
           * @param  {Object} $trigger the trigger object
           * @return {void}
           */
          var toggle = function ($trigger) {
            var $item = getItemFromTrigger($trigger);
            var $body = $item.find("[data-ty-accordion-body]");
            var $content = $item.find("[data-ty-accordion-content]");
            var isOpen = getItemIsOpen($item);
            var willOpen = !isOpen;
            var height = willOpen ? $content.get(0).scrollHeight : 0;

            setHeight($body, height);
            setClasses($item);
            setAriaValues($trigger, willOpen);
          };

          /**
           * onTriggerClick - Event handler for when an accordion trigger is clicked
           *
           * @param  {Event} e the source event from the button, or any element within it
           * @return {void}
           */
          var onTriggerClick = function (e) {
            var $trigger = angular.element(e.target);
            toggle($trigger);

            if (getItemIsOpen(getItemFromTrigger($trigger))) {
              handleAccordionTriggerOpenClicked($trigger);
            } else {
              handleAccordionTriggerCloseClicked($trigger);
            }
          };

          /**
           * init - This checks if any accordion item triggers
           *        have their aria-expanded value set to true, and sets the height
           *        and class names.
           *
           *        Called on first load, and when accordion-repeat-done and
           *        accordion-content-updated events are fired.
           *
           * @param {boolean} setHeightOnly Don't update classes ond event handlers
           * @return {void}
           */
          var init = function (setHeightOnly) {
            /*
             * If any parent elements have the is-print class,
             * don't do anything. Accordions should be expanded when printed
             */
            if ($element.closest(".is-print").length > 0) {
              return;
            }

            /*
             * We only want one accordion item open at a time, so we
             * choose the first and ignore the rest.
             */
            var $trigger = $triggers.filter('[aria-expanded="true"]').first();

            if ($trigger.length) {
              var $item = $trigger.closest("[data-ty-accordion-item]");
              var $body = $item.find("[data-ty-accordion-body]");
              var $content = $item.find("[data-ty-accordion-content]");
              var height = $content.outerHeight();

              setHeight($body, height);

              if (!setHeightOnly) {
                setClasses($item);
              }
            }

            // Event handlers
            if (!setHeightOnly) {
              $triggers.on("click", onTriggerClick);
              angular.element(window).on("beforeprint", expandForPrint);
            }
          };

          /**
           * updateElements - Updates the triggers, items, and bodies elements.
           *                  This is necessary for when an accordion is generated by
           *                  Angular (e.g. ng-repeat), or via some other dynamic method.
           *
           * @return {void}
           */
          var updateElements = function () {
            $triggers = $element.find("[data-ty-accordion-trigger]");
            $items = $element.find("[data-ty-accordion-item]");
            $bodies = $element.find("[data-ty-accordion-body]");
          };

          /**
           * onRepeatDone - An event handler for ng-repeat events finished.
           *
           *                e.g. <div
           *                    data-ng-repeat="item in items"
           *                    data-ng-init="$last && $rootScope.$broadcast('accordion-repeat-done')">
           *
           * @return {void}
           */
          var onRepeatDone = function () {
            updateElements();
            $timeout(init, INIT_DELAY_MS);
          };

          /**
           * onContentUpdated - A useful event handler for when the contents of an
           *                    accordion are manipulated by another directive or plugin.
           *
           *                    e.g.
           *                    $scope.$watch('some.variable', function() {
           *                        $rootScope.$broadcast('accordion-content-updated');
           *                    });
           *
           * @return {void}
           */
          var onContentUpdated = function () {
            $timeout(function () {
              init(true);
            });
          };

          // Push initialisation to the end of the queue, otherwise the scrollHeight will be 0
          $timeout(init);

          // Re-initialise if we're using the directive with an ng-repeeat
          $scope.$on("accordion-repeat-done", onRepeatDone);
          $scope.$on("accordion-content-updated", onContentUpdated);
        },
      };
    },
  ]);
})(window.angular);
